import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { BRAND } from "@/data/mockData";

// Once-per-session on-load intro with masked wordmark.
export default function IntroOverlay() {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    try { return !window.sessionStorage.getItem("sirija.intro.seen"); } catch { return false; }
  });

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      setShow(false);
      try { window.sessionStorage.setItem("sirija.intro.seen", "1"); } catch {}
    }, 1900);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="intro"
          data-testid="intro-overlay"
          className="fixed inset-0 z-[100] bg-[#0E0E0E] text-white flex items-end justify-between px-6 lg:px-12 pb-10 pointer-events-none"
          initial={{ y: 0 }}
          exit={{ y: "-102%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: 0.2 }}
        >
          <div className="overflow-hidden">
            <motion.div
              className="font-serif italic text-white/60 text-lg"
              initial={{ y: "110%" }} animate={{ y: 0 }} exit={{ y: "110%" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
            >
              — {BRAND.tagline}
            </motion.div>
          </div>
          <div className="overflow-hidden">
            <motion.div
              className="font-serif text-[16vw] leading-[0.85] tracking-[-0.04em] silver-shimmer"
              initial={{ y: "108%" }} animate={{ y: 0 }} exit={{ y: "-108%" }}
              transition={{ duration: 1.0, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
            >
              SIRIJA
            </motion.div>
          </div>
          <div className="overflow-hidden text-right">
            <motion.div
              className="font-mono text-[11px] uppercase tracking-[0.24em] text-white/50"
              initial={{ y: "110%" }} animate={{ y: 0 }} exit={{ y: "110%" }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            >
              Est. Pune<br/>Raviwar Peth
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
